const DIFFICULTY_TO_FORM_VALUE = {
  easy: 1,
  moderate: 2,
  challenging: 3,
  advanced: 4,
  exceptional: 5
};

function normalizeTrueFalseAnswers (possibleAnswers) {
  const trueRow = possibleAnswers.find((possibleAnswer) => /^true$/i.test(possibleAnswer.answerStatement));
  const falseRow = possibleAnswers.find((possibleAnswer) => /^false$/i.test(possibleAnswer.answerStatement));
  let trueIsCorrect = trueRow?.isCorrect ?? false;
  if (!trueRow && !falseRow && possibleAnswers[0]) {
    trueIsCorrect = Boolean(possibleAnswers[0].isCorrect);
  }
  return [
    { answerStatement: 'True', isCorrect: trueIsCorrect, hint: '' },
    { answerStatement: 'False', isCorrect: !trueIsCorrect, hint: '' }
  ];
}

/**
 * Maps a question object from POST /gemini/questions/structured into create-form values.
 */
export function mapGeminiQuestionToFormQuestion (geminiQuestion) {
  if (!geminiQuestion || typeof geminiQuestion !== 'object') return null;

  const fmt =
    geminiQuestion.questionFormat === 'true-false' ? 'true-false' : 'multiple-choice';

  const difficulty =
    DIFFICULTY_TO_FORM_VALUE[geminiQuestion.questionDifficulty] ?? 3;

  const questionStatement = String(geminiQuestion.questionStatement || '')
    .trim()
    .slice(0, 125);

  let possibleAnswers = (geminiQuestion.possibleAnswers || [])
    .map((possibleAnswer) => ({
      answerStatement: String(possibleAnswer.answerStatement || '').trim().slice(0, 125),
      isCorrect: Boolean(possibleAnswer.isCorrect),
      hint:
        typeof possibleAnswer.hint === 'string'
          ? possibleAnswer.hint.trim().slice(0, 500)
          : ''
    }))
    .filter((possibleAnswer) => possibleAnswer.answerStatement);

  if (fmt === 'true-false') {
    possibleAnswers = normalizeTrueFalseAnswers(possibleAnswers);
  } else if (possibleAnswers.length > 0 && !possibleAnswers.some((possibleAnswer) => possibleAnswer.isCorrect)) {
    possibleAnswers = possibleAnswers.map((possibleAnswer, answerIndex) =>
      answerIndex === 0 ? { ...possibleAnswer, isCorrect: true } : possibleAnswer
    );
  }

  if (fmt === 'multiple-choice' && possibleAnswers.length < 2) {
    return null;
  }

  if (!questionStatement) {
    return null;
  }

  let wrongAnswerResource;
  const geminiWrongAnswerResource = geminiQuestion.wrongAnswerResource;
  if (geminiWrongAnswerResource && typeof geminiWrongAnswerResource === 'object' && geminiWrongAnswerResource.type && geminiWrongAnswerResource.file?.url) {
    wrongAnswerResource = {
      type: geminiWrongAnswerResource.type,
      file: { url: String(geminiWrongAnswerResource.file.url).trim().slice(0, 2048) },
      learnerType: geminiWrongAnswerResource.learnerType || 'not-sure',
      title: geminiWrongAnswerResource.title != null ? String(geminiWrongAnswerResource.title).slice(0, 500) : '',
      description: geminiWrongAnswerResource.description != null ? String(geminiWrongAnswerResource.description).slice(0, 2000) : ''
    };
  }

  return {
    questionStatement,
    questionFormat: fmt,
    questionDifficulty: difficulty,
    possibleAnswers,
    hints: [],
    ...(wrongAnswerResource ? { wrongAnswerResource } : {})
  };
}
